/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
// eslint-disable-next-line import/no-duplicates
import { format } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import ptBR from 'date-fns/locale/pt-BR';

import { FiEdit, FiPower, FiRotateCcw } from 'react-icons/fi';
import {
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  Image,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { apllyToast } from '../../../Global/Toast2.0';

import ModalEditVehicle from '../../../../pages/Dashboard/Administration/Vehicles/ModalEditVehicle';
import logoAtual from '../../../../assets/logoatual.png';

import { api } from '../../../../services/api';

interface IdataTable {
  newVehicle?: unknown;
}

interface ITable2 {
  id: string;
  name: string;
  plate: string;
  year: string;
  fuel: string;
  km: string;
  image: string;
  document: string;
  status: boolean;
  observations: string;
  image_url: string;
  document_url: string;
  created_at: string;
}

interface IVehicles {
  id: string;
  name: string;
  plate: string;
  year: string;
  fuel: string;
  km: string;
  observations: string;
}

const TableVehicles: React.FC<IdataTable> = ({ newVehicle }) => {
  const [dataTable, setDataTable] = useState<ITable2[]>([]);
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [dataEditVehicle, setDataEditVehicle] = useState('');
  const [showInactive, setShowInactive] = useState(false);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    // Usa /vehicles/filter (retorna ativos E inativos). O endpoint /vehicles
    // filtra apenas ativos no backend, o que impediria ver/reativar inativos.
    api
      .get('/vehicles/filter', { params: { take: 9999, page: 1 } })
      .then(response => {
        const list = response.data?.vehicles ?? response.data;
        setDataTable(Array.isArray(list) ? list : []);
      })
      .catch(() => setDataTable([]));
  }, [newVehicle, reload]);

  const vehiclesToShow = useMemo(
    () => dataTable.filter(item => showInactive || item.status !== false),
    [dataTable, showInactive],
  );

  const handleEditVehicle = useCallback(
    (vehiclesInfo: Partial<IVehicles>, id: string) => {
      api
        .put(`/vehicles?id=${id}`, vehiclesInfo)
        .then(() => {
          apllyToast('success', 'Sucesso ao atualizar veículo!');
          setReload(prev => prev + 1);
        })
        .catch(() => {
          apllyToast('warning', 'Problemas ao atualizar veículo!');
        });
    },
    [],
  );

  const handleToggleStatus = useCallback(
    (item: ITable2, nextStatus: boolean) => {
      const actionLabel = nextStatus ? 'reativar' : 'desativar';
      // eslint-disable-next-line no-alert
      const confirmed = window.confirm(
        `Deseja realmente ${actionLabel} o veículo "${item.name}"?`,
      );
      if (!confirmed) return;

      api
        .put(`/vehicles?id=${item.id}`, { status: nextStatus })
        .then(() => {
          apllyToast(
            'success',
            `Veículo ${nextStatus ? 'reativado' : 'desativado'} com sucesso!`,
          );
          setReload(prev => prev + 1);
        })
        .catch(() => {
          apllyToast('warning', `Problemas ao ${actionLabel} o veículo!`);
        });
    },
    [],
  );

  const handleEdit = useCallback((idVehicle: string) => {
    setModalEditOpen(true);
    setDataEditVehicle(idVehicle);
  }, []);

  const toggleModalEdit = useCallback(() => {
    setModalEditOpen(prev => !prev);
    setReload(prev => prev + 1);
  }, []);

  return (
    <>
      <Box>
        <Flex justify="flex-end" mb={2}>
          <Checkbox
            isChecked={showInactive}
            onChange={event => setShowInactive(event.target.checked)}
            color="gray.500"
          >
            Mostrar inativos
          </Checkbox>
        </Flex>
        <Table colorScheme="whiteAlpha" width={100}>
          <Thead>
            <Tr>
              <Th>Veículo</Th>
              <Th>Nome</Th>
              <Th>Placa</Th>
              <Th>Combus.</Th>
              <Th>Ano</Th>
              <Th>Km</Th>
              <Th>Documento</Th>
              <Th>Status</Th>
              <Th>Data de cadastro</Th>
              <Th>Editar</Th>
              <Th>Ações</Th>
            </Tr>
          </Thead>

          <Tbody>
            {vehiclesToShow?.map(item => (
              <Tr key={item.id}>
                <Td>
                  <Image
                    src={item.image === null ? logoAtual : item.image_url}
                    alt="Imagem do veiculo"
                  />
                </Td>
                <Td>
                  <p>{item.name}</p>
                </Td>
                <Td>
                  <p>{item.plate}</p>
                </Td>
                <Td>
                  <p>{item.fuel}</p>
                </Td>
                <Td>
                  <p>{item.year}</p>
                </Td>
                <Td>
                  <p>{item.km}</p>
                </Td>
                <Td>
                  {item.document ? (
                    <Button
                      fontWeight="400"
                      border="1px"
                      _hover={{
                        color: 'yellow.500',
                        borderColor: 'yellow.500',
                      }}
                      background="#fff"
                    >
                      <a href={item.document_url} target="_blank">
                        Arquivo
                      </a>
                    </Button>
                  ) : (
                    <span>—</span>
                  )}
                </Td>
                <Td>
                  {item.status === false ? (
                    <Badge colorScheme="red">Inativo</Badge>
                  ) : (
                    <Badge colorScheme="green">Ativo</Badge>
                  )}
                </Td>
                <Td>
                  {format(new Date(item.created_at), 'dd/MM/yyyy - HH:mm:ss', {
                    locale: ptBR,
                  })}
                </Td>
                <Td>
                  <Button
                    border="1px"
                    _hover={{ color: 'yellow.500', borderColor: 'yellow.500' }}
                    background="#fff"
                    onClick={() => handleEdit(item.id)}
                  >
                    <FiEdit cursor="pointer" size={20} />
                  </Button>
                </Td>
                <Td>
                  {item.status === false ? (
                    <Button
                      border="1px"
                      _hover={{ color: 'green.500', borderColor: 'green.500' }}
                      background="#fff"
                      title="Reativar veículo"
                      onClick={() => handleToggleStatus(item, true)}
                    >
                      <FiRotateCcw cursor="pointer" size={20} />
                    </Button>
                  ) : (
                    <Button
                      border="1px"
                      _hover={{ color: 'red.500', borderColor: 'red.500' }}
                      background="#fff"
                      title="Desativar veículo"
                      onClick={() => handleToggleStatus(item, false)}
                    >
                      <FiPower cursor="pointer" size={20} />
                    </Button>
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      <ModalEditVehicle
        isOpen={modalEditOpen}
        setIsOpen={toggleModalEdit}
        handleVehicle={handleEditVehicle}
        dataEditVehicle={dataEditVehicle}
      />
    </>
  );
};

export default TableVehicles;
